import React from 'react';
import { Modal } from 'react-bootstrap';

export const InfoDesignModal = (props) => {
	return (
		<Modal {...props} aria-labelledby='contained-modal-title-vcenter' dialogClassName='modal-md modal-box' className="infodesign-modal" backdrop="static" keyboard={false}>
			<Modal.Header
				closeButton
				className='modal-header border-0'>
					<h4>{props.stolemeta && props.stolemeta.yourStolePopup && props.stolemeta.yourStolePopup.header}</h4>
				</Modal.Header>
			<Modal.Body>
				<img src={process.env.REACT_APP_JOSTENS_CDN_HOST + (props.stolemeta && props.stolemeta.image && props.stolemeta.image.yourStoleBody)||''} className="info-design-img" />
			</Modal.Body>
			<Modal.Footer>
			<p style={{fontWeight:"500",marginLeft:"20px"}}>{props.stolemeta && props.stolemeta.yourStolePopup && props.stolemeta.yourStolePopup.footer}</p>
			</Modal.Footer>
		</Modal>
	);
};
